import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import React from 'react';
import styled from 'styled-components';
import Heading from '../heading/Heading';
import Icon from '../Icon';
import Divider from '../styles/HorizontalDivider';

const CollapsableContainer = ({ heading, children, dense }) => {

    const StyledCollapsableContainer = styled.div`
        width: 94%;
        margin: 0 auto;

        & .schnoffle-collapsable-expanded h3 {
          padding: 0;
          margin-left: 40%;
          transform: translateX(-40%);
          border-bottom: 1px dashed;
        }

        & .schnoffle-expansion-dense {
          padding: 1em;
        }

        & .schnoffle-expansion {
          display: block;
        }
    `;

    const ExpandMoreIcon = (
        <Icon
            name={'icon-keyboard_arrow_down'} width='1.5em'
            height='1.5em'
        />
    );

    return (
        <StyledCollapsableContainer>
            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={ExpandMoreIcon}
                    classes={{ expanded: 'schnoffle-collapsable-expanded' }}
                >
                    <Heading level={3} text={heading} />
                </ExpansionPanelSummary>
                <ExpansionPanelDetails classes={dense ? { root: 'schnoffle-expansion schnoffle-expansion-dense' } : { root: 'schnoffle-expansion' }} >
                    {children}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </StyledCollapsableContainer>
    );
};

export default CollapsableContainer;



// WEBPACK FOOTER //
// ./src/components/common/CollapsableContainer.js